import { IconButton } from '@mui/material';
import React from 'react';

import { getBackgroundColor } from '../utils';

export interface RoundIconButtonProps {
  icon: React.ReactNode;
  onClick: () => void;
  color?: string;
  disabled?: boolean;
  'aria-label': string;
  sx?: object;
}

const BUTTON_SIZE = 40;

const RoundIconButton: React.FC<RoundIconButtonProps> = ({
  icon,
  onClick,
  color = 'primary',
  disabled = false,
  'aria-label': ariaLabel,
  sx,
}) => {
  const iconColor = getBackgroundColor(color, 1);
  const backgroundColor = getBackgroundColor(color, 0.2);

  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      sx={{
        width: BUTTON_SIZE,
        height: BUTTON_SIZE,
        borderRadius: '50%',
        color: iconColor,
        backgroundColor,
        flexShrink: 0,
        '&:hover': {
          backgroundColor: getBackgroundColor(color, 0.3),
        },
        '&.Mui-disabled': {
          color: iconColor,
          backgroundColor: getBackgroundColor(color, 0.08),
        },
        ...sx,
      }}
    >
      {icon}
    </IconButton>
  );
};

export default RoundIconButton;
